{
    "NAME": "ConfigChangeLogListLanguage",
    "ConfigChangeLogList_Column_Description": "Description",
    "ConfigChangeLogList_Column_DateTime": "Date/Time",
    "ConfigChangeLogList_Column_User": "User",
    "ConfigChangeLogList_Column_Action": "Action",
    "ConfigChangeLogList_Column_Type": "Type",
    "ConfigChangeLogList_Column_CME": "CME",
    "ConfigChangeLogList_Column_TelSys": "Telephony server",
    "ConfigChangeLogList_Column_Partition": "Partition",
    "ConfigChangeLogList_Filter_Before": "Before",
    "ConfigChangeLogList_Filter_Actions": "Actions",
    "ConfigChangeLogList_Filter_EntityTypes": "Entity types",
    "ConfigChangeLogList_Filter_MultiSelectedCount": "[{} selected]",
    "ConfigChangeLogList_Filter_SearchUsername": "Search Username",
    "ConfigChangeLogList_Filter_SuppressNulls": "Suppress null values",
    "ConfigChangeLogList_Filter_SuppressNulls_No": "No",
    "ConfigChangeLogList_Filter_SuppressNulls_Yes": "Yes",
    "ConfigChangeLogList_Filter_ActionDescription_All": "[All]",
    "ConfigChangeLogList_Filter_ActionDescription_INSERT": "Insert",
    "ConfigChangeLogList_Filter_ActionDescription_UPDATE": "Update",
    "ConfigChangeLogList_Filter_ActionDescription_DELETE": "Delete",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN": "Login",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_FAILED": "Login failed",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_AS": "Login as",
    "ConfigChangeLogList_Filter_ActionDescription_SYNC_REQUESTED": "Sync requested",
    "ConfigChangeLogList_Filter_TypeDescription_All": "[All]",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgents": "ACD agents",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgentsOwned": "ACD agents owned (memberships)",
    "ConfigChangeLogList_Filter_TypeDescription_Devices": "Devices",
    "ConfigChangeLogList_Filter_TypeDescription_DevicesOwned": "Devices owned (memberships)",
    "ConfigChangeLogList_Filter_TypeDescription_DNISAssociations": "DNIS associations",
    "ConfigChangeLogList_Filter_TypeDescription_Codes": "Codes",
    "ConfigChangeLogList_Filter_TypeDescription_CallRecordingIntegrations": "Call recording integrations",
    "ConfigChangeLogList_Filter_TypeDescription_Partitions": "Partitions",
    "ConfigChangeLogList_Filter_TypeDescription_TelephoneSystems": "Telephone systems",
    "ConfigChangeLogList_Filter_TypeDescription_Users": "Users",
    "ConfigChangeLogList_Filter_TypeDescription_CRMConfiguration": "CRM configuration",
    "ConfigChangeLogList_Detail_Title": "Audit trail entry",
    "ConfigChangeLogList_Detail_SummaryColumnItem": "Item",
    "ConfigChangeLogList_Detail_SummaryColumnValue": "Value",
    "ConfigChangeLogList_Detail_Field": "Field",
    "ConfigChangeLogList_Detail_OldValue": "Old value",
    "ConfigChangeLogList_Detail_NewValue": "New value"
}
